import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@core/ngrx-legacy';

import { GrowRolesHttpClient } from './grow-roles.http-client';
import { GrowRolesActions } from './grow-roles.store';

@Injectable({ providedIn: 'root' })
export class GrowRolesEffects {
  private readonly growRolesHttpClient = inject(GrowRolesHttpClient);
  private readonly actions$ = inject(Actions);

  public effects = createEffectFactory(GrowRolesActions, this.actions$);

  public fetch$ = this.effects(GrowRolesActions.fetch, () => this.growRolesHttpClient.fetchRoles());
}
